"use client";

import { useTranslations } from "next-intl";
import { EditableSegmentRow } from "./editable-segment-row";
import type { TranscriptSegment } from "@/lib/types/domain";

interface TranscriptSegmentsViewProps {
  segments: TranscriptSegment[];
  onSegmentTextChange?: (segmentId: string, text: string) => void;
}

export function TranscriptSegmentsView({
  segments,
  onSegmentTextChange,
}: TranscriptSegmentsViewProps) {
  const t = useTranslations("Transcript");

  if (segments.length === 0) {
    return (
      <div className="p-6 text-center text-sm text-muted-foreground">
        {t("segments.noSegments")}
      </div>
    );
  }

  return (
    <div>
      {segments.map((segment) => (
        <EditableSegmentRow
          key={segment.id}
          segment={segment}
          onTextChange={onSegmentTextChange}
        />
      ))}
    </div>
  );
}
